import axios from 'axios'
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../Common/CommonVariables'

export const GetNPSFeedbackOfCurrentMonth = async () => {
    //debugger;
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `NPSFeedback/GetNPSFeedbackOfCurrentMonth`, CommonVariables.API_HEADER)).then(response => response);
    //console.log(result)
    return result;
}

export const SaveNPSFeedback = async (data) => {
    //debugger;
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `NPSFeedback/SaveNPSFeedback`, JSON.stringify(data), CommonVariables.API_HEADER)).then(response => response);
    return result;
}